import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import Notiflix from "notiflix";

export const MySwal = withReactContent(Swal);

const load = Notiflix.Loading;

export const loading = () => {
  load.pulse({
    backgroundColor: "rgba(0,0,0,0.35)",
  });
};

export const removeLoading = () => {
  load.remove();
};

export const success = (text, func) => {
  Notiflix.Report.success(text, "", "Devam Et", () => (func != undefined ? func() : null));
};

export const failed = (text) => {
  Notiflix.Report.failure(text, "", "Tamam");
};

export const warning = (text, options) => {
  document.dispatchEvent(new CustomEvent("notificationEvt", { detail: { msg: text, status: "warning" } }));
  Notiflix.Notify.warning(
    text,
    {
      messageMaxLength: 1000,
      timeout: 5 * 1000, // 5 * 1000 Milisaniye = 5 Saniye
      ...options,
      clickToClose: true, // Uyarıya tıklanınca kapatma özelliği
      position: "center-top",
    },
    "Devam Et"
  );
};
